import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: `${API}/api`, withCredentials: true });

// Tasks
export const getTasks = (params) => api.get('/tasks', { params });
export const getTask = (id) => api.get(`/tasks/${id}`);
export const createTask = (data) => api.post('/tasks', data);
export const updateTask = (id, data) => api.put(`/tasks/${id}`, data);
export const deleteTask = (id) => api.delete(`/tasks/${id}`);

// Comments
export const getComments = (taskId) => api.get(`/tasks/${taskId}/comments`);
export const addComment = (taskId, text) => api.post(`/tasks/${taskId}/comments`, { text });

// Screenshots
export const uploadScreenshot = (taskId, type, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/tasks/${taskId}/screenshot/${type}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Attachments
export const uploadAttachment = (taskId, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/tasks/${taskId}/attachments`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// General upload
export const uploadFile = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// File download URL
export const getFileUrl = (storagePath) => `${API}/api/files/${storagePath}`;

// Download file as blob (for images)
export const downloadFileBlob = async (storagePath) => {
  const resp = await api.get(`/files/${storagePath}`, { responseType: 'blob' });
  return URL.createObjectURL(resp.data);
};

// Master data
export const getTeams = () => api.get('/teams');
export const createTeam = (data) => api.post('/teams', data);
export const updateTeam = (id, data) => api.put(`/teams/${id}`, data);
export const deleteTeam = (id) => api.delete(`/teams/${id}`);

export const getBrands = () => api.get('/brands');
export const createBrand = (data) => api.post('/brands', data);
export const updateBrand = (id, data) => api.put(`/brands/${id}`, data);
export const deleteBrand = (id) => api.delete(`/brands/${id}`);

export const getDomains = () => api.get('/domains');
export const createDomain = (data) => api.post('/domains', data);
export const deleteDomain = (id) => api.delete(`/domains/${id}`);

export const getUsers = () => api.get('/users');
export const changeUserRole = (userId, role) => api.put(`/users/${userId}/role`, { role });

// Notifications
export const getNotifications = () => api.get('/notifications');
export const createNotification = (data) => api.post('/notifications', data);
export const updateNotification = (id, data) => api.put(`/notifications/${id}`, data);
export const deleteNotification = (id) => api.delete(`/notifications/${id}`);
export const markNotificationRead = (id) => api.post(`/notifications/${id}/read`);
export const getNotificationReadStatus = () => api.get('/notifications/read-status');

// Feature Requests
export const createFeatureRequest = (data) => api.post('/feature-requests', data);
export const getFeatureRequests = () => api.get('/feature-requests');
export const updateFeatureRequestStatus = (id, status) => api.put(`/feature-requests/${id}/status`, { status });
export const deleteFeatureRequest = (id) => api.delete(`/feature-requests/${id}`);
export const uploadFeatureRequestAttachment = (id, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/feature-requests/${id}/attachment`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// PDP Variations
export const getPDPVariations = () => api.get('/pdp-variations');
export const createPDPVariation = (data) => api.post('/pdp-variations', data);
export const updatePDPVariation = (id, data) => api.put(`/pdp-variations/${id}`, data);
export const deletePDPVariation = (id) => api.delete(`/pdp-variations/${id}`);
export const uploadPDPScreenshot = (id, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/pdp-variations/${id}/screenshot`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Website Speed
export const getWebsiteSpeed = () => api.get('/website-speed');

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');

// AI
export const aiSummarize = (title, description) => api.post('/ai/summarize', { title, description });
export const aiSuggestPriority = (title, description) => api.post('/ai/suggest-priority', { title, description });
export const aiSuggestTags = (title, description) => api.post('/ai/suggest-tags', { title, description });

// A/B Tests
export const getABTests = (params) => api.get('/ab-tests', { params });
export const getABTest = (id) => api.get(`/ab-tests/${id}`);
export const createABTest = (data) => api.post('/ab-tests', data);
export const updateABTest = (id, data) => api.put(`/ab-tests/${id}`, data);
export const deleteABTest = (id) => api.delete(`/ab-tests/${id}`);
export const uploadABScreenshot = (testId, variant, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/ab-tests/${testId}/screenshot/${variant}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const getTaskABTests = (taskId) => api.get(`/tasks/${taskId}/ab-tests`);

// Google Auth
export const exchangeGoogleSession = (session_id) => api.post('/auth/google/session', { session_id });
export const googleLogout = () => api.post('/auth/google/logout');
